<template>
  <el-table :data="loading || error ? [] : items" row-key="id" border stripe height="100%" class="manager-table" style="width:100%">
    <slot />
    <template slot="empty">
      <div class="table-state" role="status">
        <span>{{ loading ? '正在加载...' : error || emptyText }}</span>
        <button v-if="error && !loading" type="button" @click="$emit('retry')">重试</button>
      </div>
    </template>
  </el-table>
</template>

<script>
import Table from 'element-ui/lib/table'
import 'element-ui/lib/theme-chalk/index.css'

export default {
  name: 'ManagerTable',
  components: { 'el-table': Table },
  props: {
    items: { type: Array, default: () => [] },
    loading: Boolean,
    error: { type: String, default: '' },
    emptyText: { type: String, default: '暂无记录' }
  }
}
</script>

<style scoped>
.manager-table { min-width:0; }
::v-deep th.el-table__cell { height:46px; padding:0; color:#728789; background:#f9fbfa; font-size:12px; font-weight:600; }
::v-deep td.el-table__cell { padding:10px 0; color:#355056; font-size:13px; }
::v-deep .cell { padding:0 12px; line-height:1.6; overflow-wrap:anywhere; }
::v-deep .el-table__empty-block { width:100% !important; min-height:180px; }
::v-deep .el-table__empty-text { width:100%; line-height:1.6; }
.manager-table::before { display:none; }
.table-state { display:flex; align-items:center; justify-content:center; gap:10px; min-height:180px; padding:20px; color:#8a9b9b; font-size:13px; }
.table-state button { border:0; color:#237f78; background:none; cursor:pointer; font:inherit; text-decoration:underline; }
</style>
